import request from "@/utils/request.js"
// 获取新闻列表
export function get_list(data){
  return request({
    	  method:'GET',
    	  url:'/news/get_list',
    	  params:data
    })
}
// 获取新闻详情
export function get_read(data){
  return request({
    	  method:'GET',
    	  url:'/news/read',
    	  params:data
    })
}
